import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";

const PendingInformation = ({ t, i18n }) => {
  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "We’ve received your application but we need more information - HARP - Government of Nova Scotia";
    } else {
      document.title =
        "Nous avons reçu votre demande, mais nous avons besoin de plus de renseignements – PAC – Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);
  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            <div className="container">
              <div className="row">
                <div className="row">
                  <div className="col-xs-12 col-sm-8">
                    <h2 style={{ marginBottom: 0 }}>
                      {t("application_status.more_info_title")}
                    </h2>
                    <br />
                    <span>{t("application_status.either_mailed")}</span>
                    <br />
                    <br />
                    <span>{t("application_status.call_for_more_detail")}</span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-8">
                  <h3>{t("confirmation.questions")}</h3>
                  <h5>{t("application_status.contact_us")}</h5>
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(PendingInformation);
